var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntrestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3874_883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.5L17.25 0.75L6 12L0.75 10.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 10.5L17.25 0.75L6 12L0.75 10.5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.94544 11.7894L0.75 10.5L6 12L17.25 0.75L5.94544 11.7894Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12L7.5 17.25L8.25 12.375L17.25 0.75L6 12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.5L7.5 17.25L8.25 12.375L11.25 13.5Z",
    fill: "#E6E6E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12L7.5 17.25L8.25 12.375L17.25 0.75L6 12Z",
    fill: "url(#paint0_linear_3874_883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15L17.25 0.75L8.25 12.375L15 15Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.4348 12.4469L17.25 0.75L8.25 12.375L8.4348 12.4469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.851 14.7411L8.25 12.375L15 15L17.25 0.75L14.851 14.7411Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.22 13.53L7.5 17.25L8.25 12.375L11.22 13.53Z",
    fill: "url(#paint1_linear_3874_883)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M7.5 17.25L11.22 13.53L11.033 13.4572L7.5 17.25Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.22 13.53L8.25 12.375L10.3125 14.4375L11.22 13.53Z",
    fill: "url(#paint2_linear_3874_883)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0.75L0.75 10.5L6 12L7.5 17.25L11.22 13.53L15 15L17.25 0.75Z",
    fill: "url(#paint3_linear_3874_883)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3874_883",
    x1: 10.6875,
    y1: 7.3125,
    x2: 14.0625,
    y2: 10.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3874_883",
    x1: 7.2975,
    y1: 13.3275,
    x2: 9.36,
    y2: 15.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3874_883",
    x1: 8.70375,
    y1: 11.9212,
    x2: 10.7663,
    y2: 13.9837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3874_883",
    x1: 3.4005,
    y1: 4.815,
    x2: 16.8293,
    y2: 11.0768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3874_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrestIcon);
export default __webpack_public_path__ + "static/media/intrest-icon.cecf80898a24120b0cebe99f694e30ed.svg";
export { ForwardRef as ReactComponent };